import React, { useEffect, useState } from 'react'
import { Button, Chip, Dialog, DialogActions, DialogContent, DialogTitle, Grid, TextField, Tooltip, Checkbox, InputAdornment } from '@material-ui/core'
import { Autocomplete } from '@material-ui/lab'
import { regexConstants } from '../../../../constants/regEx'
import { globalGetService, globalPostService } from '../../../../globalServices'
import { checkApiStatus } from '../../../../utils_v2'
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers'
import MomentUtils from '@date-io/moment'
import { assetId, backendDateFormat, fieldDateFormat } from '../../../../constants'
import moment from 'moment'
import { useSnackbar } from 'notistack'
import { PageLoader } from '../../../../shared_elements'

export default function AddCashAllocation({ onClose, params, getResponseBack }) {
    const [allocationData, setAllocationData] = useState({ is_same_asset: true })
    const [fromReserveAccounts, setFromReserveAccounts] = useState([])
    const [toReserveAccounts, setToReserveAccounts] = useState([])
    const [assetsList, setAssetsList] = useState([])
    const [error, setError] = useState([])
    const [isLoading, setLoading] = useState(false)
    const {enqueueSnackbar} = useSnackbar()
    useEffect(() => {
        getAssetsList()
        getFromReserveAccounts()
        getToReserveAccounts()
    }, [])
    const onFieldChange = (key, value) => {
        if(key =='asset'){
            getToReserveAccounts(value)
            setAllocationData({ ...allocationData,to_account_type:null ,[key]: value })
        }else{
        setAllocationData({ ...allocationData, 
            entry_date: key === 'account_type'? null :key ==='entry_date'? value:  allocationData?.entry_date,
            amount: key=== 'account_type'?'': allocationData.amount,
            to_account_type:key=== 'is_same_asset'?null:allocationData?.to_account_type,
            asset:key=== 'is_same_asset'?null:allocationData?.asset,
            [key]: value })
    }
    }
    const getAssetsList = () => {
        globalGetService('contracts/v2/list-lease-assets/?switcher=true&application=3', {remove_asset_slug: params?.aircraft_slug})
            .then(response => {
                if (checkApiStatus(response)) {
                    setAssetsList(response.data.data?.asset)
                }
            })
    }
    const getFromReserveAccounts =()=>{
        globalGetService(`contracts/${params?.contract_slug}/cash-allocation/reserve`)
        .then(response=>{
            setFromReserveAccounts(response.data.data)
        })
    }
    const getToReserveAccounts =(data)=>{
        globalGetService(`contracts/${params?.contract_slug}/cash-allocation/reserve`,{asset_type:data?.asset_type, asset_id:data?.id})
        .then(response=>{
            setToReserveAccounts(response.data.data?.reserve_accounts || [])
        })
    }
    const onAddAllocation = () => {
        let validateNewInput={}
        validateNewInput={
            ...validateNewInput,
            asset:allocationData.is_same_asset?'': allocationData.asset ?'':'Please select Asset.' ,
            account_type: allocationData?.account_type ? '': 'Please select account type',
            to_account_type: allocationData?.to_account_type ? allocationData?.to_account_type?.id === allocationData?.account_type?.id ?  'Transfers within the same account are not allowed.' : '': 'Please select account type',
            entry_date:allocationData?.entry_date ? moment(allocationData?.entry_date).isValid()? moment(allocationData?.entry_date).diff(moment(allocationData?.account_type?.last_transaction_date)) <0?'Entry date cannot be prior to last payment date.':  '':'Please enter valid Date':'Please select Entry Date',
            amount: allocationData?.amount ?allocationData?.amount > allocationData?.account_type?.balance ?  'Transfer amount cannot be more than available amount'  : '' : 'Please enter amount to transfer'
        }
        if(Object.keys(validateNewInput).every(k=> {return validateNewInput[k] =='' })){
        let fromData={
            asset_slug:params.aircraft_slug,
            asset_type:assetId[params.type],
        }
        let payload ={
            entry_date:allocationData?.entry_date,
            amount:parseFloat(allocationData?.amount),
            from:{...fromData,reserve_account_id:allocationData?.account_type?.id},
            to:allocationData.is_same_asset?{
                ...fromData,reserve_account_id:allocationData?.to_account_type?.id
            }:{
                asset_slug:allocationData?.asset?.slug,
                asset_type:allocationData?.asset?.asset_type,
                reserve_account_id:allocationData?.to_account_type?.id
            }
        }
        setLoading(true)
        globalPostService(`contracts/cash-allocation/transfer`, payload)
        .then(response=>{
            setLoading(false)
            if(checkApiStatus(response)){
                onClose()
                getResponseBack()
                enqueueSnackbar(response?.data?.message, { variant: 'success', anchorOrigin: { vertical: 'top', horizontal: 'right' } });
            }
        })
    } else {
        setError(validateNewInput)
    }
    }
    
    return (
        <div >
            {isLoading? <PageLoader/>:null}
            <Dialog style={{ zIndex: "300" }} open='true' onClose={onClose} maxWidth={'md'} className='mou-dialog'>
                <DialogTitle> Cash Allocation </DialogTitle>
                <DialogContent dividers >
                    <Grid container spacing={1} className='add-csh-alcn'>
                        <Grid item sm='12'>
                            <div className='asset-check-bx'>
                                <Checkbox
                                    color="primary"
                                    size='small'
                                    checked={allocationData.is_same_asset ? true : false}
                                    onChange={(e) => {onFieldChange('is_same_asset', e.target.checked);setToReserveAccounts([]) }}
                                    value="Reserve Rate Not Applicable"
                                />
                                Within asset </div>
                        </Grid>
                        <Grid item sm='6'>
                            <div className='section-hds'>Cash Allocation From {fromReserveAccounts?.asset_details?.unique_name}</div>
                            <div className='frm-section-fields'>
                                <Autocomplete
                                    options={fromReserveAccounts?.reserve_accounts || []}
                                    getOptionLabel={option => option?.name || '--'}
                                    value={allocationData?.account_type || null}
                                    id="account_type"
                                    renderOption={(props, option) => <li {...props}>{props.name}{props?.is_grouped_lgs && <span style={{ marginLeft: 6 }} className="grouped-lg">Grouped LG</span>}</li>}
                                    onChange={(e, value) => onFieldChange('account_type', value)}
                                    renderInput={params => <TextField onFocus={()=>setError({...error, account_type:''})} error={error?.account_type ? true: false} helperText={error?.account_type ? error?.account_type :''} required placeholder={''} label='Select Account' style={{ padding: '0px' }} {...params} InputLabelProps={{ shrink: true }} variant="outlined" 
                                    InputProps={{ ...params.InputProps, endAdornment: <>{allocationData?.account_type && allocationData?.account_type.is_grouped_lgs && <span className="grouped-lg" style={{ marginRight: 8 }}>Grouped LG</span>}{params.InputProps.endAdornment}</> }} />}
                                />
                                <TextField
                                    id="amount"
                                    label='Available Amount'
                                    disabled={true}
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    margin="normal"
                                    value={allocationData?.account_type?.balance || allocationData?.account_type?.balance == 0 ? allocationData?.account_type?.balance: ''}
                                    variant='outlined'
                                    InputProps={{
                                        startAdornment: (<InputAdornment position="start" >US$</InputAdornment>)
                                    }}
                                />
                                <TextField
                                    id="amount"
                                    required
                                    InputLabelProps={{ shrink: true }}
                                    fullWidth
                                    label='Transfer Amount'
                                    inputProps={{ maxLength: 40 }}
                                    margin="normal"
                                    value={allocationData.amount || ''}
                                    variant='outlined'
                                    error={error?.amount ? true: false}
                                    helperText={error?.amount ? error?.amount :''}
                                    onFocus={()=>setError({...error, amount:''})}
                                    onChange={(e) => { regexConstants?.numberWithDot.test(e.target.value) ? onFieldChange('amount', e.target.value) : e.preventDefault() }}
                                    InputProps={{
                                        startAdornment: (<InputAdornment position="start" >US$</InputAdornment>)
                                    }}
                                />
                                <MuiPickersUtilsProvider utils={MomentUtils}>
                                    <KeyboardDatePicker
                                        required
                                        placeholder='DD-MM-YYYY'
                                        style={{ position: "relative", top: '16px' }}
                                        inputVariant="outlined"
                                        variant='outlined'
                                        margin="none"
                                        id="entry_date"
                                        label="Entry Date"
                                        disabled={allocationData?.account_type ? false:true}
                                        minDate={moment(allocationData?.account_type?.last_transaction_date || '01-01-1900')}
                                        maxDate={moment()}
                                        value={allocationData?.entry_date ? allocationData?.entry_date : null}
                                        format={fieldDateFormat}
                                        fullWidth
                                        onFocus={()=>setError({...error, entry_date:''})}
                                        error={error?.entry_date ? true: false}
                                        helperText={error?.entry_date ? error?.entry_date :''}
                                        InputLabelProps={{ shrink: true }}
                                        onChange={(data, value) => { onFieldChange('entry_date', data ? moment(data).format(backendDateFormat) : null) }}
                                    />
                                </MuiPickersUtilsProvider>
                            </div>
                        </Grid>
                        <Grid item sm='6'>
                            <div className='section-hds'>Cash Allocation To {allocationData.is_same_asset? fromReserveAccounts?.asset_details?.unique_name:allocationData?.asset?.unique_name}</div>
                            <div className='frm-section-fields'>
                                {allocationData.is_same_asset ? null :
                                    <Autocomplete
                                        options={assetsList}
                                        getOptionLabel={option => option?.unique_name || '--'}
                                        value={allocationData?.asset || null}
                                        id="asset"
                                        style={{ marginBottom: '20px' }}
                                        onChange={(e, value) => onFieldChange('asset', value)}
                                        renderInput={params => <TextField required  error={error?.asset ? true: false} helperText={error?.asset ? error?.asset :''} onFocus={()=>setError({...error, asset:''})} placeholder={''} label='Select Asset' style={{ padding: '0px' }} {...params} InputLabelProps={{ shrink: true }} variant="outlined" />}
                                    />}
                                <Autocomplete
                                    options={ allocationData.is_same_asset ? fromReserveAccounts?.reserve_accounts : toReserveAccounts}
                                    getOptionLabel={option => option?.name || ''}
                                    value={allocationData?.to_account_type || null}
                                    id="to_account_type"
                                    style={{ marginBottom: '20px' }}
                                    onChange={(e, value) => onFieldChange('to_account_type', value)}
                                    renderInput={params => <TextField onFocus={()=>setError({...error, to_account_type:''})} error={error?.to_account_type ? true: false} helperText={error?.to_account_type ? error?.to_account_type :''}  required placeholder={''} label='Select Account' style={{ padding: '0px' }} {...params} InputLabelProps={{ shrink: true }} variant="outlined" />}
                                />
                            </div>
                        </Grid>
                    </Grid>
                </DialogContent>
                <DialogActions>
                    <Button style={{ marginLeft: "15px" }} color="primary" size='small' variant='outlined' onClick={onClose}>Cancel</Button>
                    <Button style={{ marginLeft: "15px" }} color="primary" size='small' variant='contained' onClick={onAddAllocation}>Proceed</Button>
                </DialogActions>
            </Dialog>
        </div>
    )
}
